import { HTTPClient } from '../utils/request'

export default {
  store: ({ params, payload }) =>
    HTTPClient.post(`/driver/victimology/${params._id}`, payload),
  update: ({ params, payload }) =>
    HTTPClient.put(`/driver/victimology/${params._id}/${payload._id}`, payload),
  remove: ({ params }) =>
    HTTPClient.delete(`/driver/victimology/${params._id}/${params.vic_id}`),
}